module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Shopping/Chart-bar1-ea8d5679363b1a722127333dcff2200e.svg";